import { useLinkConversationToOpportunityMutation } from "@qw/graphql";
import { Button, Icon, Tooltip, TooltipContent, TooltipTrigger } from "@qw/ui";
import { type FC, useCallback } from "react";

export const LinkOpportunityButton: FC<{
  conversationId: string;
  opportunityId: string;
}> = ({ conversationId, opportunityId }) => {
  const [linkConversationToOpportunity] = useLinkConversationToOpportunityMutation({
    refetchQueries: ["InboxConversation"],
  });

  const handleClick = useCallback(async () => {
    await linkConversationToOpportunity({
      variables: { input: { conversationId, opportunityId } },
    });
  }, [conversationId, opportunityId, linkConversationToOpportunity]);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="xs"
          display="icon"
          className="group/button opacity-0 group-hover:opacity-100 transition-opacity"
          onClick={handleClick}
        >
          <Icon icon="link_off" className="group-hover/button:hidden" />
          <Icon icon="link" className="hidden group-hover/button:inline" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Link Marketing Plan</TooltipContent>
    </Tooltip>
  );
};
